import {MI} from "../init";
import AbstractSymbol from "./AbstractSymbol";

/**
 * @constructor
 * @extends {AbstractSymbol}
 * @param {MadnesObject} sprite
 * @param {number} symbolNum
 * @param {number} reelX
 * @param {number} reelY
 */
export default function SymbolCandle(sprite, symbolNum, reelX, reelY) {
    AbstractSymbol.call(this, sprite, symbolNum, reelX, reelY);

    /** @type {MadnesObject|null} */
    this._flameObject;
    /** @type {MadnesObject|null} */
    this._winShineObject;
    /** @type {MadnesAnims|null} */
    this._winShineAnim;
    /** @type {Function|null} */
    this._winAnimResolver;
};

SymbolCandle.prototype = Object.create(AbstractSymbol.prototype);
SymbolCandle.prototype.constructor = SymbolCandle;

SymbolCandle.shineColor = 0xe36500;

/**
 * @returns {number}
 */
SymbolCandle.prototype.getShineColor = function() {
    return SymbolCandle.shineColor;
};

/**
 * @private
 * @returns {undefined}
 */
SymbolCandle.prototype.clear = function() {
    //this.parentSprite.setTexture(null);
    this._clearParentSprite();

    this.shineSymbol = null;
    this.destroyShineAnim();

    /*this._winShineObject = null;
    this._winShineAnim = null;
    this._flameObject = null;
    */
    this._winAnimResolver = null;

    this.removeChilds();
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SymbolCandle.prototype.createSymbol = function() {
    this.clear();
    this.createImage(0, 0, "symbols_atlas").setFrameName(this.symbolName);
    this._flameObject = this.createImage(5, -80, "flame_atlas").setBlend("ADD");
    this._flameObject.setScale(2, 2);

    return this;
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SymbolCandle.prototype.createSimpleSymbol = function() {
    this.clear();
    this.createImage(0, 0, "symbols_atlas").setFrameName(this.symbolName);
    return this;
};

SymbolCandle.prototype.createStandAnim = function() {
    this.shineSymbol = this.createImage(0, 0, "symbols_atlas").setFrameName(this.symbolName + "_shine").setBlend("ADD");//.setScale(1.5, 1.5); //.setVisible(false);
    this.createShineAnim();

    this._flameObject.createAnims();
    this._flameObject.anims.add("flame", MI.randomizeFrames(MI.generateFrameNames("flame_candle_", 0, 14, "", 5)));
};

SymbolCandle.prototype.playStandAnim = function() {

    if(!this.shineSymbol) return;

    this.shineSymbol.setVisible(true);

    this._flameObject.setVisible(true);
    this._flameObject.anims.loop("flame");
};

SymbolCandle.prototype.stopStandAnim = function() {
    if(this._flameObject && this._flameObject.anims) {
        this._flameObject.anims.stop();
    }
};

SymbolCandle.prototype.fadeOutStandAnim = function() {};
SymbolCandle.prototype.fadeInStandAnim = function() {};

/**
 * @returns {SymbolCandle}
 */
SymbolCandle.prototype.createWinSymbol = function() {
    this.createSymbol();

    this._winShineObject = this.createImage(0, 0, "symbol_Candle_atlas")
        .setBlend("ADD").setScale(2, 2).setVisible(false).setAlpha(1);
    this._winShineAnim = this._winShineObject.createAnims();
    this._winShineAnim.add("shine", MI.generateFrameNames("symbol_Candle_", 0, 19, "", 5));

    this._winShineAnim.addOnComplete(function() {
        this._winAnimResolver();
    }.bind(this));

    return this;
};

SymbolCandle.prototype.playWinAnim = function() {
    return new Promise(function(res) {

        this._winAnimResolver = res;

        this._winShineObject.setVisible(true);
        this._winShineAnim.play("shine");

    }.bind(this));
};

SymbolCandle.prototype.stopWinAnim = function() {
    this._winAnimResolver = null;
    this._winShineAnim && this._winShineAnim.stop();
};

SymbolCandle.prototype.destroyWinAnim = function() {
    this._winShineObject.destroy();
    this._winShineAnim = null;
};